export { default } from "./tabs-buttons";
